import{SESSION_URLS_STORAGE_KEY as S}from"../../../constants/SESSION_URLS_STORAGE_KEY/SESSION_URLS_STORAGE_KEY.js";var o=function(o){return void 0===o&&(o=S),sessionStorage.removeItem(btoa(String(o)))};export{o as removePrAppUrls};
//# sourceMappingURL=removePrAppUrls.js.map
